import React from "react";
import ermv from "../../img/ermv.svg";
import "./Menu.css"
import  logo from "../../img/logo_stc.svg";
import Home from "./../../img/Home.svg";
import Regalo from "./../../img/Regalo.svg";
import Carrito from "./../../img/Carrito.svg";
import Bolsa from "./../../img/Bolsa.svg";
import Gracias from "./../../img/Gracias.svg";
import {showMenu, tables_link} from "../extras/Actions";


export default class Menu extends React.Component{
    render() {
        return (
            <div className="menu">
                <div className="logos big">
                    <a href="/">
                        <img src={ermv} alt="" className="ermv"/>
                    </a>

                    <button className="burger-menu" onClick={showMenu}>
                        <i className="fa-solid fa-bars"></i>
                    </button>
                </div>

                <div className="items">
                    <a href="/">
                        <img src={Home} alt=""/>
                        <p>
                            ¿Por qué el regalo más valioso?
                        </p>
                    </a>
                    <a href="/gifts">
                        <img src={Regalo} alt=""/>
                        <p>Elige qué<br/> regalar</p>
                    </a>
                    <a href="/donors">
                        <img src={Gracias} alt=""/>
                        <p>Gracias por<br/> sus regalos</p>
                    </a>
                    <a href={tables_link}>
                        <img src={Bolsa} alt=""/>
                        <p>
                            Haz tu propia <br/>mesa
                        </p>
                    </a>
                    <a href="/cart" className={"cart"}>
                        <span className="items">0</span>
                        <img src={Carrito} alt=""/>
                        <p>
                            Carrito de <br/>
                            compras
                        </p>
                    </a>
                </div>
                <div className="logos2">
                    <a href="/">
                        <img src={logo} alt="" className="ermv"/>
                    </a>
                </div>
            </div>
        );
    }
}